<template>
    <div name="modal" v-show="visible">
        <div
            class="modal modal-mask"
            id="modal-idle"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-idle"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <!-- Header -->

                    <div class="modal-header">
                        <h3 class="modal-title">Logging out</h3>
                    </div>

                    <!-- Body -->

                    <div class="modal-body">
                        <p class="mb-5">You will be automatically logged out in {{counter}} seconds.</p>
                        <a
                            class="btn-large btn-blue float-right"
                            @click="stayLoggedIn"
                        >Stay logged in</a>

                        <a
                            class="btn-large btn-red float-right text-center mr-2"
                            @click="doLogOut"
                        >Log out</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Idle",

        props: ["visible", "counter"],

        methods: {
            stayLoggedIn() {
                this.$emit("stayLoggedIn");
            },
            doLogOut(){
                this.$emit("doLogOut");
            }
        }
    };
</script>
<style>
    .modal-body {
        overflow: hidden;
    }
    p {
        margin: 1rem 0 3rem 0;
    }
</style>